import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";
import React from "react";

function RecruiterSettingsPage() {
  return <div className="bg-white shadow-xl py-8 px-2 rounded-2xl container mx-auto my-6">RecruiterSettingsPage</div>;
}
export default RecruiterLayerBlueprint(RecruiterSettingsPage);
